import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CustomerService } from './customer.service';
import { ErrorService } from './error.service';
import { FileService } from './file.service';
import { SpinnerService } from './spinner.service';

@Injectable({ providedIn: 'root' })
export class FileViewerService {
	private _fileExtensionRegex = /(?:\.([^.]+))?$/;
	private _isOpeningSubject = new BehaviorSubject<boolean>(false);
	public readonly isOpening$ = this._isOpeningSubject.asObservable();

	constructor(private _fileService: FileService,
				private _customerService: CustomerService,
				private _errorService: ErrorService,
				private _spinnerService: SpinnerService) { }

	openFile(file: any): void {
		if (this._isOpeningSubject.value) {
			return;
		}

		this._isOpeningSubject.next(true);
		this._spinnerService.startSpinner();
		const fileType = this._fileExtensionRegex.exec(file.fileName)[1];
		const selectedCustomer = this._customerService.getSelectedCustomer();
		const convertTo = fileType === 'pdf' ? fileType : selectedCustomer ? selectedCustomer.defaultImageConversion : 'NO_CONVERSION';
		requestAnimationFrame(() => {
			this._fileService.getFile(file.id, convertTo)
				.pipe(finalize(() => {
					this._isOpeningSubject.next(false);
					this._spinnerService.stopSpinner();
				}))
				.subscribe(
					(response) => {
						const blob = this._fileService.convertToBlob(response);
						if ((window.navigator as any).msSaveBlob) {
							return (window.navigator as any).msSaveBlob(blob, response.fileName);
						}
						const reader: any = new FileReader();
						reader.onload = (e) => {
							let content;
							if (reader.result.includes('image')) {
								content = new Image();
								content.src = reader.result;
							}
							const newTab = window.open();
							if (newTab) {
								newTab.document.write(content ? content.outerHTML : '<iframe src="' + reader.result + '" frameborder="0" class="no-border-full-screen" allowfullscreen></iframe>');
							} else {
								this._errorService.error({
									detailedMsg: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
									generalMsg: 'Pop-up blocked!'
								}, null, 'modal');
							}
						};
						reader.readAsDataURL(blob);
					},
					(error) => {
						this._errorService.error(error, 'openFile Failed', 'modal');
					}
				);
		});
	}
}
